export default __webpack_public_path__ + "static/media/Azadi-Ka-Amrit-Mahotsav-Logo.5369f414.png";